import React from 'react';

import { Banner } from '../Banner/Banner';
import { About } from '../About/About';
import { Portfolio } from '../Portfolio/Portfolio';
import { Contact } from '../Contact/Contact';
import './Main.css';

export function Main() {

    return (
        <main>
            <Banner />
            <About />
            <Portfolio />
            <Contact />
        </main>
    )
    
}

// Foto de Peng LIU: https://www.pexels.com/es-es/foto/marco-de-edificio-elevado-169647/